export const CONTACT = {
  COMPANY_NAME_TH: "บริษัท ซีทีเอส กรุ๊ป จำกัด",
  COMPANY_NAME_EN: "CTS Group Co., Ltd.",
  PHONE: "087-074-2282",
  PHONE_LABEL: "K. Kaew",
  PHONE_DISPLAY: "087-074-2282 (K. Kaew)",
  PHONE_TEL: "tel:087-074-2282",
  LINE_ID: "@cts_group",
  LINE_URL: "https://line.me/R/oaMessage/%40cts_group",
  WEBSITE: "www.ctscarprotection.com",
  WEBSITE_URL: "https://www.ctscarprotection.com",
  FACEBOOK: "ctsgroup01",
  FACEBOOK_URL: "https://www.facebook.com/ctsgroup01",
  INSTAGRAM: "the_cts_group",
  INSTAGRAM_URL: "https://www.instagram.com/the_cts_group",
  YOUTUBE_URL: "https://www.youtube.com/@ctsgroup",
  ADDRESS_TH: "2232 ถ.เพชรบุรีตัดใหม่ บางกะปิ ห้วยขวาง กรุงเทพ 10310",
  ADDRESS_EN: "2232 New Petchburi Rd., Bangkapi, Huai Khwang, Bangkok 10310",
  HOURS: "9:00-18:00",
  SERVICE_TH: "บริการรับ-ส่งรถถึงที่",
  SERVICE_EN: "Mobile shuttle pickup available",
};
